import {
	SEMANTIC_POSITION,
	Shader,
	ShaderUtils,
	type GraphicsDevice,
} from "playcanvas";

export interface ShaderSource {
	readonly glsl: string;
	readonly wgsl: string;
}

export interface QuadShaderOptions {
	name: string;
	fragment: ShaderSource;
}

/**
 * Fullscreen shader helper ported from @animech/playcanvas-scripts
 * src/utilities/shaders.ts at revision 99958e178f0271cd7a8d82416b6c9c175140b035.
 * The donor project is ISC-licensed; this local adaptation retains that
 * attribution while limiting the port to the quad-shader factory used here.
 */
export function createQuadShader(
	device: GraphicsDevice,
	options: QuadShaderOptions,
): Shader {
	for (const language of ["glsl", "wgsl"] as const) {
		if (!options.fragment[language]?.trim()) {
			throw new Error(
				`${options.name}: missing ${language.toUpperCase()} shader source`,
			);
		}
	}

	return ShaderUtils.createShader(device, {
		uniqueName: options.name,
		attributes: { aPosition: SEMANTIC_POSITION },
		vertexChunk: "quadVS",
		fragmentGLSL: options.fragment.glsl,
		fragmentWGSL: options.fragment.wgsl,
	});
}
